import * as React from 'react';

export const BothDirectionIcon: React.FunctionComponent = () => (
  <svg
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
  >
    <path
      d="M3.5 7.5V12.5H8.5"
      stroke="#7A7A7A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 8.5L12.5 3.5L7.5 3.5"
      stroke="#7A7A7A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.5 12.5L12.5 3.5" stroke="#7A7A7A" />
  </svg>
);
